<template>
    <div class="content-question-input-textarea">
        <textarea-input :enumeration="numberContent"
                        :error-text="translate('label.this_value_is_required')"
                        :field-id="question.questionId"
                        :help-text="question.additionalInfo"
                        :input-class="'form-control question-input-text-single'"
                        :label="labelContent"
                        :label-class="'text-color-questions'"
                        :limit-size="question.sizeBox"
                        :model-answer="question.answer"
                        :name="fieldName"
                        :placeholder="question.placeholder ? question.placeholder : 0"
                        :type="'text'"
                        :validation="validationRules"
                        :has-submitted="hasSubmitted"
                        v-on:update:modelAnswer="changeValue($event, question)"/>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import TextareaInput from "../components/textarea-input.vue";
import { useTranslation } from '@/composables/useTranslation';

// INITIALIZE STORES & COMPOSABLES
const playerStore = usePlayerStore();
const { translate } = useTranslation();

// PROPS & EMITS
const props = defineProps({
    enumeration: {
        type: Number,
        required: false,
        default: 0,
    },
    question: {
        type: Object,
        required: true,
    },
    showNumbering: {
        type: Boolean,
        required: false,
        default: false,
    },
    store: {
        type: Object,
        required: true
    },
    TYPE_FIELD_ID: {
        type: Number,
        required: true,
    },
    hasSubmitted: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['field-change', 'register-field']);

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const fieldName = computed(() =>
    `question_${props.TYPE_FIELD_ID}_${props.question.questionId}_${props.question.fieldType}`
);

const labelContent = computed(() => {
    const label = [];

    if (Boolean(props.question.required)) {
        label.push(`* ${props.question.description}`);
    } else {
        label.push(props.question.description);
    }

    return label.join(' ');
});

const numberContent = computed(() => {
    const label = [];

    if (Boolean(props.showNumbering)) {
        label.push(`${String(props.enumeration).padStart(2, '0')}.`);
    }

    return label.join('');
});

const validationRules = computed(() => {
    const rules = {
        required: false,
        max: 1000,
    };
    if (props.question.required) {
        rules.required = true;
    }
    if (Number(props.question.characterLimit) !== 0) {
        rules.max = 'max:' + props.question.characterLimit;
    }

    return rules;
});

// METHODS
const changeValue = (newValue, qt) => {
    qt.answer = newValue;
    emit('field-change', fieldName.value, newValue);
    playerStore.setAnswerInFormQuestions(qt);
};

// LIFECYCLE HOOKS
onMounted(async () => {
    // Registrar este campo en el formulario padre
    emit('register-field', fieldName.value, props.question.answer || '');

    if (props.question.fieldType === 'countries') {
        countries.value = playerStore.getCountriesData;
    }
});
</script>
